import * as Sentry from '@sentry/browser';

/** Prefix for support / customer copy-paste from the service worker console. */
export const SHAREPOINT_LB_DIAG_LOG_PREFIX = '[Drumkit SharePoint LB diag]';

export type SharepointLbDiagEvent =
  'hostTabBound' | 'workbookContextForbidden' | 'sharepointHostMountBlocked';

export function logSharepointLbDiag(
  event: SharepointLbDiagEvent,
  payload: Record<string, unknown>
): void {
  console.info(SHAREPOINT_LB_DIAG_LOG_PREFIX, event, payload);
  Sentry.addBreadcrumb({
    category: 'sharepointLoadBuilding',
    message: event,
    data: payload,
    level: 'info',
  });
}
